import { ChannelType, NotificationChannel } from '../../gql/generated';
import { InfoRow, InfoSectionHeader } from '../SidePanel';

interface ChannelDetailsTabProps {
  channel: NotificationChannel;
  groupedChannelNames: string[];
}

const channelTypeLabels: Record<ChannelType, string> = {
  [ChannelType.Email]: 'Email',
  [ChannelType.Teams]: 'Teams',
  [ChannelType.Grouped]: 'Grouped',
};

export function ChannelDetailsTab({
  channel,
  groupedChannelNames,
}: ChannelDetailsTabProps) {
  const groupedIds = channel.groupedChannelIds || [];
  const groupedNamesValue = groupedChannelNames.length
    ? groupedChannelNames.join(', ')
    : undefined;

  return (
    <div className='flex flex-col'>
      <section>
        <InfoSectionHeader>Channel</InfoSectionHeader>
        <div className='flex flex-col gap-2 px-6 py-4'>
          <InfoRow label='Name' value={channel.name} />
          <InfoRow label='Description' value={channel.description} />
          <InfoRow label='Type' value={channelTypeLabels[channel.channelType]} />
          <InfoRow label='Status' value={channel.isEnabled ? 'Enabled' : 'Disabled'} />
          <InfoRow label='Internal ID' value={channel.id} />
        </div>
      </section>

      <section>
        <InfoSectionHeader>Delivery</InfoSectionHeader>
        <div className='flex flex-col gap-2 px-6 py-4'>
          <InfoRow label='Email recipients' value={channel.email} />
          <InfoRow label='Webhook URL' value={channel.webhookUrl} />
        </div>
      </section>

      <section>
        <InfoSectionHeader>Grouped channels</InfoSectionHeader>
        <div className='flex flex-col gap-2 px-6 py-4'>
          <InfoRow
            label='Linked channels'
            value={groupedNamesValue || 'No linked channels'}
          />
          <InfoRow
            label='Linked IDs'
            value={groupedIds.length ? groupedIds.join(', ') : undefined}
          />
        </div>
      </section>
    </div>
  );
}
